import React, { useContext } from "react";
import { Button } from "reactstrap";
import "./index.scss";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { resetReadOnlyDoc } from "../../../context/actions/document"
import { SocketContext } from "../../../context/actions/socket";

const Logo = ({ className = '' }) => {
	const dispatch = useDispatch();
	const selectedFile = useSelector((state) => state.document.fileData);
	const history = useHistory();
	const userDetail = useSelector((state) => state?.user?.user);
	const { backendSocket } = useContext(SocketContext);

	const dashboardUrl = (redirectUrl) => {
		// if(selectedFile?.reading_by === userDetail?._id && selectedFile?.read_only){
		// 	dispatch(resetReadOnlyDoc({ docId: selectedFile._id}, (result) => {
		// 		if(result){
		// 			backendSocket.emit('check-doc-status', selectedFile)
		// 			console.log(selectedFile._id," doc reset")
		// 		}
		// 	}))
		// }
		history.push(redirectUrl)
	}
	const logo = useSelector((state) => state?.user?.logo);
	return (
		<>
			<Button color="link p-0"
				onClick={() => dashboardUrl('/dashboard')}
				className={`logo-cell shadow-none ${className}`}>
				{/* {logo ?
					<img className='img-fluid' src={logo} alt='Logo' />
					: <img className="img-fluid" src={require("../../../assets/img/Main_Logo.png")} alt="Logo" />

				} */}
				<img className="img-fluid" src={require("../../../assets/img/Main_Logo.png")} alt="Logo" />
			</Button>
		</>
	)
};
export default Logo;